import CreateSafetyAnchorPointRequestModelBase from '../_generated/modelBases/create-safety-anchor-point-request-model-base';

export default class CreateSafetyAnchorPointRequestModel extends CreateSafetyAnchorPointRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
